module.exports = __webpack_public_path__ + "media/src/assets/Images/Print-fb80cf6f64577b87bf53f81e296208be.svg";